/**
 * The country page's Gateways view (19/10/2026): the day plan the page
 * already holds (planned and sent per gateway) plus the gateways overview
 * read (rates, blocks, winners, prices), narrowed to the open campaign group.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC, useState } from 'react';

import { GatewaysTabCard } from '@/features/drop-generator/components/gateways-tab/GatewaysTabCard';
import type { DayPlanPreview } from '@/features/drop-generator/drop-generator.types';
import { useErrorsReport } from '@/features/drop-generator/hooks/useErrorQueries';
import { useGatewaysOverview, useGatewayTrends } from '@/features/drop-generator/hooks/useLiveQueries';

export const GatewaysTab: FC<{
  countryKey: string;
  at: string | null;
  preview: DayPlanPreview | undefined;
  previewLoading: boolean;
  previewFailed: boolean;
  onRetryPreview: () => void;
  scopeIds?: ReadonlySet<string> | null;
  scopeLabel?: string | null;
  onEditContainer?: (containerId: string) => void;
  onOpenMasterGateways?: () => void;
  onOpenErrors?: () => void;
}> = ({ countryKey, at, preview, previewLoading, previewFailed, onRetryPreview, scopeIds = null, scopeLabel = null, onEditContainer, onOpenMasterGateways, onOpenErrors }) => {
  const overview = useGatewaysOverview(countryKey, at);
  const errors = useErrorsReport(countryKey, 1, at);
  const [days, setDays] = useState(14);
  const trends = useGatewayTrends(countryKey, days, at);
  return (
    <GatewaysTabCard
      preview={preview}
      overview={overview.data}
      loading={previewLoading || overview.isLoading}
      failed={previewFailed || overview.isError}
      onRetry={() => {
        onRetryPreview();
        void overview.refetch();
      }}
      scopeIds={scopeIds}
      scopeLabel={scopeLabel}
      onEditContainer={onEditContainer}
      onOpenMasterGateways={onOpenMasterGateways}
      countryKey={countryKey}
      trends={{ data: trends.data, days, onDays: setDays, loading: trends.isLoading }}
      errors={errors.data?.rows ?? []}
      onOpenErrors={onOpenErrors}
    />
  );
};
